import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../services/api'
import Loading from '../../components/Loading'

function EventStatus() {
  const params = useParams()
  // const [loading, setLoading] = useState(true)
  const [loaded, setLoaded] = useState(false)
  const [ev, setEv] = useState({})
  const [usersInEvent, setUsersInEvent] = useState([])
  const [portaria, setPortaria] = useState([])
  const [userHistoryEvents, setUserHistoryEvents] = useState([])

  useEffect(() => {
    onLoad()
  }, [params])

  async function onLoadPortaria() {
    const res = await api.get('host')
    setPortaria(res.data)
  }

  async function usuarios() {
    const user = await api.get('credit/users')
    if (user.data) {
      setUsersInEvent(user.data)
    }
  }

  async function getUsersThatExistEvent(){
    const user = await api.get('userHistoryEvents/' + params.id)
    if (user.data) {
      setUserHistoryEvents(user.data)
    }
  }

  async function onLoad() {
    if (params.id !== undefined) {
      try {
        const ev = await api.get(`events/${params.id}`)
        setEv(ev.data)
        await usuarios()
        await onLoadPortaria()
        await getUsersThatExistEvent()
      } catch (e) {}
      setLoaded(true)
    }

    // setLoading(false)
  }

  if (!loaded) {
    return (
      <div>
        <Loading size={50} />
      </div>
    )
  }

  if (!ev.name) {
    return <div>Evento não encontrado :(</div>
  }

  return (
    <div>
      <div className="card my-2 mb-3">
        <div className="card-header">
          <h2>{ev.name}</h2>
        </div>
        <div className="card-body">
          <p className="card-text"><strong>Início:</strong> {new Date(ev.start).toLocaleString()}</p>
          <p className="card-text"><strong>Término:</strong> {new Date(ev.end).toLocaleString()}</p>
          <p className="card-text"><strong>Total que passaram no Evento:</strong> {userHistoryEvents.length}</p>
        </div>
      </div>
      <div className="d-flex flex-wrap justify-content-around">
        <div className="text-center m-2">
          <h3>Na Fila ({portaria.length})</h3>
          <ul className="list-group">
            {portaria.map((person, index) => (
              <li key={index} className="list-group-item">
                <a href={`/usuario/${person.userId}`}>
                {index + 1} | {person.userName}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="text-center m-2">
          <h3>No Evento ({usersInEvent.length})</h3>
          <ul className="list-group">
            {usersInEvent.map((person, index) => (
              <li key={index} className="list-group-item">
                <a href={`/usuario/${person.userId._id}`}>
                  {index + 1} | {person.userName}{person.userId.name} - {person.tag}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="text-center m-2">
          <h3>Saíram ({ userHistoryEvents.filter(person => person.exitAt).length} )</h3>
          <ul className="list-group">
            {userHistoryEvents.filter(person => person.exitAt).map((person, index) => (
              <li key={index} className="list-group-item">
                <a href={`/usuario/${person.userId}`}>
                {index + 1} | {person.userName}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default EventStatus
